import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-asset-management-authoring-tools',
  templateUrl: './asset-management-authoring-tools.component.html',
  styleUrls: ['./asset-management-authoring-tools.component.scss']
})
export class AssetManagementAuthoringToolsComponent {
    constructor(private router: Router){}
     
   sidebarActive: boolean=true;

    assetCapture(){
      this.router.navigate(['asset-management/auth-tools/asset-capture/search']);
    }
    back(){
      this.router.navigate(['asset-management/tools']);
    }
    assetView(){
      this.router.navigate(['asset-management/auth-tools/asset-view']);
    }
    
}
